/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BalanceBackofficeDto } from './balanceBackofficeDto';

/**
 * Balance DTO
 */
export interface AccountBalance {
  accountId: number;
  globalCredit?: number;
  usedGlobalCredit?: number;
  usdNotional?: number;
  balances: Array<BalanceBackofficeDto>;
}
